import React, { useState } from "react"
import { Helmet } from "react-helmet"

// Detecting the changes in mobile position(landscape, portrait)

const MobileOrientation = () => {
  const [open, setOpen] = useState(true)
  if (typeof window !== "undefined") {
    window.addEventListener("orientationchange", function(event) {
      setOpen(!open)
      console.log(open)
    })
  }

  return (
    <Helmet defer={false}>
      {/* adding viewport meta 
    tags in the head based on the mobile position (to make it full size on the landscape mode)*/}
      {!open ? (
        <meta
          name="viewport"
          content="initial-scale=1"
          content="viewport-fit=cover"
        />
      ) : (
        <meta name="viewport" content="width=device-width,shrink-to-fit=no" />
      )}
          
    </Helmet>
  )
}
export default MobileOrientation
